import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/jobs/job.svg")